<template>
    <div class="operation">
        <Title chineseTitle="运行监控" englishTitle="operation monitoring and controlling" />
        <div class="operationHandle" @click="showDeviceList = !showDeviceList">
            <img src="../../assets/img/change.png" alt="" />
            <span>{{details[currentDeviceDetail].loopName}}</span>
            <!-- <span>{{details[currentDeviceDetail].subLoopUrl}}</span> -->
        </div>
        <div class="deviceList" v-show="showDeviceList">
            <img class="close" @click="showDeviceList = false" src="../../assets/img/close.png" alt="关闭" />
            <div class="type row-center">
                <span>回路列表</span>
            </div>
            <div class="names">
                <span v-for="(item, index) in details" :class="{ active: currentDeviceDetail === index }" :key="index"
                    @click="currentDeviceDetail = index">
                    {{ item.loopName }}
                </span>
            </div>
        </div>

        <div class="operationContent">
            <div class="firstLine">
                <OperationData :data="{
                    key: '功率因数',
                    value:$store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/PF'] == 'NaN'?'--':$store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/PF'],
                    unit: '',
                    icon: icon(),
                }" />
                <OperationData :data="{
                    key: '有功功率',
                    value:$store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/P'] == undefined ? $store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/P'] : ($store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/P'] / 1000),
                    unit: ' kW',
                }" />
                <OperationData :data="{
                    key: '无功功率',
                    value: $store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/PR'] == undefined ? $store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/PR'] : ($store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/PR'] / 1000),
                    unit: ' kVar',
                }" />
                <!-- <OperationData :data="{
                    key: '谐波率',
                    value: $store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/THD_U'],
                    unit: ' %',
                }" /> -->
                <OperationData :data="{
                    key: '负荷不平衡',
                    value: $store.getters.unbalance(details[currentDeviceDetail].subLoopUrl),
                    unit: ' %',
                }" />
            </div>

            <div class="secondLine">
                <div class="line"></div>
                <div class="title">三相电流(A):</div>
                <div class="data">
                    <div class="value">A:
                        {{$store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/Ia'] == undefined ? '--' : parseFloat(Number($store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/Ia']).toFixed(2))}}
                    </div>
                    <div class="value">B:
                        {{$store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/Ib'] == undefined ? '--' : parseFloat(Number($store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/Ib']).toFixed(2))}}
                    </div>
                    <div class="value">C:
                        {{$store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/Ic'] == undefined ? '--' : parseFloat(Number($store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/Ic']).toFixed(2))}}
                    </div>
                </div>
            </div>

            <div class="secondLine" v-if="$store.state.projectId != 2 && $store.state.projectId !== 5">
                <div class="line"></div>
                <div class="title">母排温度(℃):</div>
                <div class="data" v-if="details[currentDeviceDetail].busbarTemperature == 1">
                    <div class="value">A:
                        {{$store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/Temperature_in_A'] == undefined ? '--' : parseFloat(Number($store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/Temperature_in_A']).toFixed(2))}}
                    </div>
                    <div class="value">B:
                        {{$store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/Temperature_in_B'] == undefined ? '--' : parseFloat(Number($store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/Temperature_in_B']).toFixed(2))}}
                    </div>
                    <div class="value">C:
                        {{$store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/Temperature_in_C'] == undefined ? '--' : parseFloat(Number($store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/Temperature_in_C']).toFixed(2))}}
                    </div>
                </div>
                <div class="data" v-else>
                    <div class="value">A:
                        {{$store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/Temperature_A'] == undefined ? '--' : parseFloat(Number($store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/Temperature_A']).toFixed(2))}}
                    </div>
                    <div class="value">B:
                        {{$store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/Temperature_B'] == undefined ? '--' : parseFloat(Number($store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/Temperature_B']).toFixed(2))}}
                    </div>
                    <div class="value">C:
                        {{$store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/Temperature_C'] == undefined ? '--' : parseFloat(Number($store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/Temperature_C']).toFixed(2))}}
                    </div>
                </div>
            </div>

            <div class="secondLine" v-if="$store.state.projectId == 2">
                <div class="line"></div>
                <div class="title">线缆温度(℃):</div>
                <div class="data">
                    <div class="value">
                        {{$store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/Temperature'] == undefined ? '--' : parseFloat(Number($store.state.MQTTObj[details[currentDeviceDetail].subLoopUrl + '/Temperature']).toFixed(2))}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Title from "@/components/Title.vue";
    import DataItem from "@/components/DataItem";
    import OperationData from "@/components/OperationData";
    import {
        GetAllLoopsByProjectId
    } from "@/components/Request"
    import {
        subscribebySubLoopUrl,
        unsubscribebySubLoopUrl
    } from "@/mqtt/index"

    export default {
        name: "SiteOperationData",
        components: {
            Title,
            DataItem,
            OperationData,
        },
        props: ["areaId"],
        data() {
            return {
                currentDeviceDetail: 0,
                showDeviceList: false,
                details: [
                    [{
                        name: "A1配电柜",
                        value: "A1/ZTR1/",
                    }, {
                        name: "A2配电柜",
                        value: "A2/ZTR1/",
                    }],
                ],
            }
        },
        mounted() {
            GetAllLoopsByProjectId({
                projectId: this.$store.state.projectId,
            }).then(({
                data
            }) => {
                let datas = data.data.deviceLoops
                console.log(datas);
                this.details = datas.filter(item => item.aid == this.areaId && item.loopType !== "BREAKER" && item.loopType !=="CAPCABINET" && item.loopType !=="SENSOR" && item.loopType !=="TRANSFORMER")
                this.details.forEach(item => {
                    if (item.subLoopUrl)
                        subscribebySubLoopUrl([
                            item.subLoopUrl + '/PF',
                            item.subLoopUrl + '/P',
                            item.subLoopUrl + '/PA',
                            item.subLoopUrl + '/PA_total',
                            item.subLoopUrl + '/PR',
                            item.subLoopUrl + '/THD_U',
                            item.subLoopUrl + '/Ia',
                            item.subLoopUrl + '/Ib',
                            item.subLoopUrl + '/Ic',
                            item.subLoopUrl + '/Ua',
                            item.subLoopUrl + '/Ub',
                            item.subLoopUrl + '/Uc',
                            item.subLoopUrl + '/Uab',
                            item.subLoopUrl + '/Uac',
                            item.subLoopUrl + '/Ubc',
                            item.subLoopUrl + '/Temperature_A',
                            item.subLoopUrl + '/Temperature_B',
                            item.subLoopUrl + '/Temperature_C',
                            item.subLoopUrl + '/Temperature_in_A',
                            item.subLoopUrl + '/Temperature_in_B',
                            item.subLoopUrl + '/Temperature_in_C',
                            item.subLoopUrl + '/Temperature',
                            item.subLoopUrl + '/SwitchOn',
                        ])
                })
                this.bus.$on('changeLoop', this.handle)
                // this.bus.$on('changeLoop', (areaId, loopId) => {
                //     if (this.areaId == areaId)
                //         this.currentDeviceDetail = this.details.findIndex(item => item.loopId == loopId)
                // })
            }).catch(err => {
                console.log(err)
            })
        },
        beforeDestroy() {
            this.bus.$off('changeLoop', this.handle)
            this.details.forEach(item => {
                if (item.subLoopUrl)
                    unsubscribebySubLoopUrl([
                        item.subLoopUrl + '/PF',
                        item.subLoopUrl + '/PA',
                        item.subLoopUrl + '/P',
                        item.subLoopUrl + '/PA_total',
                        item.subLoopUrl + '/PR',
                        item.subLoopUrl + '/THD_U',
                        item.subLoopUrl + '/Ia',
                        item.subLoopUrl + '/Ib',
                        item.subLoopUrl + '/Ic',
                        item.subLoopUrl + '/Ua',
                        item.subLoopUrl + '/Ub',
                        item.subLoopUrl + '/Uc',
                        item.subLoopUrl + '/Uab',
                        item.subLoopUrl + '/Uac',
                        item.subLoopUrl + '/Ubc',
                        item.subLoopUrl + '/Temperature_A',
                        item.subLoopUrl + '/Temperature_B',
                        item.subLoopUrl + '/Temperature_C',
                        item.subLoopUrl + '/Temperature',
                        item.subLoopUrl + '/SwitchOn',
                    ])
            })
        },
        methods: {
            icon() {
                let data = this.$store.state.MQTTObj[this.details[this.currentDeviceDetail].subLoopUrl + '/PF']
                if (!data) {
                    return "";
                } else if (data > 0.9) {
                    return "优";
                } else if (data > 0.5) {
                    return "良";
                } else {
                    return "差";
                }
            },
            handle(areaId, loopId) {
                if (this.areaId == areaId)
                    this.currentDeviceDetail = this.details.findIndex(item => item.loopId == loopId)
            }
        }
    };
</script>

<style lang="less" scoped>
    .operation {
        position: fixed;
        top: 880/108vh;
        left: 14600/192vw;

        .operationHandle {
            width: 4000/192vw;
            height: 400/108vh;
            background: rgba(3, 13, 24, 0.75);
            margin-left: 1vw;
            font-size: 18rem;
            color: #e6f3fd;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            cursor: pointer;

            img {
                margin-left: 120/192vw;
                margin-right: 110/192vw;
                width: 160/192vw;
                height: 130/108vh;
            }
        }

        .operationContent {
            width: 4000/192vw;
            height: 1200/108vh;
            background: rgba(3, 13, 24, 0.75);
            margin-left: 1vw;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: center;
            overflow: hidden;

            .firstLine {
                width: 4000/192vw;
                margin-bottom: 50/108vh;
                overflow: hidden;
                display: flex;
                flex-direction: row;
            }

            .secondLine {
                width: 95%;
                height: 28%;
                font-size: 14rem;
                color: rgba(230, 248, 255);
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;

                .line {
                    width: 2px;
                    height: 140/108vh;
                    background: rgba(13, 148, 255, 0.3);
                }

                .title {
                    width: 25%;
                    display: flex;
                    flex-direction: row;
                    // justify-content: space-around;
                }

                .data {
                    width: 70%;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;

                    .value {
                        width: 30%;
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                    }
                }
            }
        }

    }

    .deviceList {
        width: 100%;
        height: 100%;
        z-index: 100;
        position: absolute;
        left: -4080/192vw;
        top: 0;
        color: #ffffff;
        font-size: 18rem;
        background-image: url("../../assets/img/安防列表.png");
        background-size: 100% 100%;
        padding-top: 230/108vh;
        padding-left: 240/192vw;
        padding-right: 180/192vw;

        .close {
            position: absolute;
            top: 230/108vh;
            right: 200/192vh;
            width: 190/192vw;
            height: 180/108vh;
            cursor: pointer;
        }

        .active {
            color: #0d94ff;
        }

        .names {
            height: 60%;
            align-items: flex-start;
            overflow-y: auto;
            display: flex;
            flex-direction: column;

            span {
                margin-bottom: 230/108vh;
                cursor: pointer;
            }
        }

        .type {
            justify-content: flex-start;
            border-bottom: 1px solid rgba(255, 255, 255, 0.75);
            margin-bottom: 160/108vh;

            span {
                margin-right: 330/192vw;
                margin-bottom: 130/108vh;
            }
        }
    }

    .names::-webkit-scrollbar {
        width: 50/192vw;
        height: 1px;
    }

    .names::-webkit-scrollbar-thumb {
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(255, 255, 255, 0.7);
    }

    // .names::-webkit-scrollbar-track {
    //     box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    //     border-radius: 10px;
    //     background: #111;
    // }
</style>